function EmptyState({ message, variant = "empty" }) {
  return (
    <p className={`state-message${variant === "error" ? " error" : ""}`}>
      {message}
    </p>
  );
}

export default EmptyState;
